exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\n  text-align: left; }\n\n.form-group {\n  margin-bottom: 12px; }\n\n::-webkit-input-placeholder {\n  /* Chrome/Opera/Safari */\n  color: #e62700;\n  font-style: italic; }\n\n::-moz-placeholder {\n  /* Firefox 19+ */\n  color: #e62700;\n  font-style: italic; }\n\n:-ms-input-placeholder {\n  /* IE 10+ */\n  color: #e62700;\n  font-style: italic; }\n\n:-moz-placeholder {\n  /* Firefox 18- */\n  color: #e62700;\n  font-style: italic; }\n\nspan.busy-txt {\n  margin-right: 12px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/site-admin/preferences/my-profile/my-profile.component.scss
// module id = ../../../../../src/app/views/site-admin/preferences/my-profile/my-profile.component.scss
// module chunks = main